module.exports = __webpack_public_path__ + "img/store-active.ee315f25.png";